ci_states
  .state("customers_view.ads.ad_view", {
    url: "/:ad_id",
    views: {
      "@": {
        templateUrl: "partials/ad/ad_view.html",
        controller: "AdViewController",
      },
    },
    ncyBreadcrumb: {
      parent: function($scope) {
        $scope.$watch(
          "stateParams",
          function() {
            if ($scope.stateParams) {
              return "customers_view.ads({id:" + $scope.stateParams.id + "})";
            }
          },
          true
        );
      },
      label: "{{ ad.name }}",
    },
  })
  .state("customers", {
    url: "/customers",
    templateUrl: "partials/advertiser/advertiser_list.html",
    controller: "AdvertiserListController",
    ncyBreadcrumb: {
      label: "Customers",
    },
  })
  .state("customers_view", {
    url: "/customers/:id",
    abstract: true,
    templateUrl: "partials/advertiser/advertiser_view.html",
    controller: "AdvertiserViewController",
    reloadOnSearch: true,
    ncyBreadcrumb: {
      parent: "customers",
      label: "{{ advertiser.name || ad.advertiser.name}}",
    },
  })
  .state("customers_view.users", {
    url: "/users",
    controller: "UserListController",
    templateUrl: "partials/user/user_list.html",
    ncyBreadcrumb: {
      label: "Users",
    },
  })
  .state("customers_view.ads", {
    url: "/ads",
    controller: "AdListController",
    templateUrl: "partials/ad/ad_list.html",
    ncyBreadcrumb: {
      label: "Creatives",
    },
  })
  .state("customers_view.applications", {
    url: "/applications",
    controller: "ApplicationListController",
    templateUrl: "partials/application/application_list.html",
    ncyBreadcrumb: {
      label: "Applications",
    },
  })
  .state("customers_view.campaigns", {
    url: "/campaigns?list_start&list_end&q",
    controller: "CampaignListController",
    templateUrl: "partials/campaign/campaign_list.html",
    reloadOnSearch: true,
    ncyBreadcrumb: {
      label: "Campaigns",
    },
  });
